import { useState } from 'react'
import useMountEffect from '../useMountEffect'

const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState(false)
  useMountEffect(() => {
    setIsMounted(true)
  })
  return isMounted
}

export default useIsMounted
